import React from 'react';
import { Link } from 'react-router-dom';

const NotFound = () => {
  return (
    <div className="container mx-auto py-16 text-center">
      <div className="mb-8">
        <span className="text-9xl font-bold text-gray-200">404</span>
      </div>
      
      <h1 className="text-4xl font-bold mb-4">Page Not Found</h1>
      
      <p className="text-xl text-gray-600 mb-8 max-w-lg mx-auto">
        The page you are looking for doesn't exist or has been moved.
      </p>
      
      <Link to="/" className="btn btn-primary px-6 py-3">
        Back to Home
      </Link>
    </div>
  );
};

export default NotFound;